import { Action } from 'redux';

import { IContentInfo } from '../../../ts/models/IContentInfo';
import { EditWorkbook } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface EditWorkbookAction extends Action {
  workbook: IContentInfo;
}

export function editWorkbook(workbook: IContentInfo): EditWorkbookAction {
  return {
    type: EditWorkbook,
    workbook
  };
}

export const isEditWorkbookAction = isActionFactory<EditWorkbookAction>(EditWorkbook);
